// extracted by css-extract-rspack-plugin
export default {"root":"zeYGW","image":"cEy10"};